import { Add, Edit, Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { EPrefContentTypeDialog } from "./EPrefContentTypeDialog";
import { EPrefItemDto } from "./types";

export function EPrefContentTypeListPage() {
    const [useStore] = useState(() => createListStore<EPrefItemDto>({
        path: "settings/ePrefContent",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "name", label: "Name", width: 200 },
            { column: "isUnique", label: "Unique", width: 120, type: "bool" },
            { column: "isActive", label: "Active", width: 120, type: "bool" },
            { column: "priority", label: "Priority", width: 120 },
        ],
    }));

    const ePreferencesItems = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteItem() {
        await simpleDialog.show("Email preference content types", "Delete email preference content type?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/ePrefContent/${ePreferencesItems?.selectedItem?.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <EPrefContentTypeDialog close={close} ePrefItem={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const editDialog = useDialog(close => <EPrefContentTypeDialog close={close} ePrefItem={ePreferencesItems.selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Email preference content types" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={ePreferencesItems.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={ePreferencesItems.selectedItem == null} title="Delete" onClick={deleteItem}><Delete /></Button>],
            ]),
        })}
    </>;
}
